import './index.css';


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-license-submit/style/index.js